// module imports
import Link from 'next/link';

// file imports
import { IEvent, IPresentation } from '@/types';
import { QuestionSelector } from '@/components';

interface PostEventTabProps {
  event: IPresentation | IEvent | null;
  slug: string;
}

export default function PostEventTab({ event, slug }: PostEventTabProps) {
  const speakerName = (event?.user && typeof event.user === 'object' && event?.user?.name) || 'Speaker';
  const reportUrl = event?.eventType === 'Event' ? `/events/${slug}/report` : `/presentations/${slug}/report`;

  return (
    <div className="bg-gray-50 min-h-screen p-3 sm:p-4 lg:p-6">
      {event?.responses !== undefined && event?.responses > 0 && (
        <div className="flex justify-end mb-3 sm:mb-4">
          <Link href={reportUrl} className="inline-flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors border border-blue-200">
            View Report
          </Link>
        </div>
      )}
      <QuestionSelector slug={slug} speakerName={speakerName} />
    </div>
  );
}
